$(function () {
    // Kolla om det finns något element med classen dynamisktinnehall
    var dynamisktinnehallSelector = '.dynamisktinnehall';
    if ($(dynamisktinnehallSelector).length > 0) {
        //
        var laddarClass = 'dynamisktinnehall-laddar';
        var urlAttr = 'data-url';
        var objAttr = 'data-obj';
        var objError = 'data-error';

        // Lägg till classen dynamisktinnehall-laddar på alla dessa element
        $(dynamisktinnehallSelector).addClass(laddarClass);

        // Loopa alla hittade element
        $(dynamisktinnehallSelector).each(function () {
            var currentElement = $(this);
            var fullPath = currentElement.attr(urlAttr);
            var dataval = currentElement.attr(objAttr);
            var dataerror = currentElement.attr(objError);

            // Sätt ihop json object
            var dynamisktInnehall = {obj: dataval};

            // Anropa webapi
            $.ajax({
                type: 'POST',
                url: fullPath,
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(dynamisktInnehall),
                dataType: 'json',
                success: function (data) {
                    // Sätt in returnerad html in i element
                    currentElement.html(data.content);

                    // Cleanup
                    currentElement.removeAttr(urlAttr);
                    currentElement.removeAttr(objAttr);
                    currentElement.removeClass(laddarClass);
                },
                error: function () {
                    // Cleanup
                    currentElement.removeAttr(urlAttr);
                    currentElement.removeAttr(objAttr);
                    currentElement.removeAttr(objError);
                    currentElement.removeClass(laddarClass);
                    currentElement.html(dataerror);

                    console.debug('fail to load:' + fullPath);
                }
            });
        });
    }
});
